export default __webpack_public_path__ + "static/media/onloop_logo.464c9559.jpg";